import BaseGrid from '@components/tables/BaseGrid';
import OrderLinkDetailsCellRenderer from '@components/tables/cells/OrderLinkDetailsCellRenderer';
import PaymentStatusCellRenderer from '@components/tables/cells/PaymentStatusCellRenderer';
import OrderStatusCellRenderer from '@components/tables/cells/OrderStatusCellRenderer';
import CopyToClipboardAndToggleCellRenderer from '@components/tables/cells/CopyToClipboardAndToggleCellRenderer';
import MultiLinesHeader from '@components/tables/headers/MultiLinesHeader';
import OrderStatusChipAgGrid from '@components/chips/OrderStatusChipAgGrid';
import OfferTokenStatusChip from '@components/chips/OfferTokenStatusChip';
import CampaignStatusChip from '@components/chips/CampaignStatusChip';
import MultiValueToggleCellRenderer from '@components/tables/cells/MultiValueToggleCellRenderer';
import RemoveRowCellRenderer from '@components/tables/cells/RemoveRowCellRenderer';
import RateTextCellRenderer from '@components/tables/cells/RateTextCellRenderer';
import FilterFormRow from '@components/forms/FilterFormRow';
import FilterFormCell from '@components/forms/FilterFormCell';

import '@scss/main.scss';
import { appFactory } from '@/helpers';

const app = appFactory.create({});

app.component('BaseGrid', BaseGrid);
app.component('OrderLinkDetailsCellRenderer', OrderLinkDetailsCellRenderer);
app.component('PaymentStatusCellRenderer', PaymentStatusCellRenderer);
app.component('OrderStatusCellRenderer', OrderStatusCellRenderer);
app.component('CopyToClipboardAndToggleCellRenderer', CopyToClipboardAndToggleCellRenderer);
app.component('MultiLinesHeader', MultiLinesHeader);
app.component('OrderStatusChipAgGrid', OrderStatusChipAgGrid);
app.component('FilterFormRow', FilterFormRow);
app.component('FilterFormCell', FilterFormCell);
app.component('OfferTokenStatusChip', OfferTokenStatusChip);
app.component('CampaignStatusChip', CampaignStatusChip);
app.component('MultiValueToggleCellRenderer', MultiValueToggleCellRenderer);
app.component('RemoveRowCellRenderer', RemoveRowCellRenderer);
app.component('RateTextCellRenderer', RateTextCellRenderer);
